import { css } from '@emotion/css';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    FooterNavCol,
    FooterNavRow,
    StyledFooter
} from './styles/Footer.styled';
import moment from 'moment';

interface Item {
    title: string
    links: NavLink[]
}

interface NavLink {
    name?: string
    url: string
    img?: string
    target?: string
}

const Footer = () => {
    const { t } = useTranslation()
    let navigate = useNavigate();

    const nav: Item[] = [
        // {
        //     title: t('Products'),
        //     links: [
        //         { name: t('PoweLego'), url: 'https://www.powerlego.com/', target: '_blank' },
        //         { name: t('EIQhome'), url: 'https://www.eiqhome.com/', target: '_blank' },
        //         { name: t('EIQShopping'), url: `https://www.eiqshopping.com/`, target: '_blank' },
        //         { name: t('ESIID.io'), url: `https://www.esiid.io/`, target: '_blank' },
        //         { name: t('BillReader'), url: `https://www.billreader.com/`, target: '_blank' },
        //     ],
        // },
        {
            title: t('Legal & Policiese'),
            links: [
                { name: t('Terms of Use'), url: '/terms_of_service', },
                { name: t('Privacy Policy'), url: '/privacy_policy', },

            ],
        },
        {
            title: t('Support & Contact'),
            links: [
                { name: 'Contact Us', url: '/contact' },
            ],
        },

        // {
        //     title: t('Secure'),
        //     links: [
        //         { name: 'amazon', img: '/images/footer_logo.png', url: '#' },
        //         // { name: 'eiqdigital', img: '/images/logo_eiqdigital.png', url:'https://www.eiqdigital.com/'}
        //     ],
        // },
        {
            title: t('Developers'),
            links: [
                { name: 'Documentation', url: 'https://documenter.getpostman.com/view/4831254/SzKYPH3c' }
            ]
        }
    ]

    const location = useLocation()
    const isHome = location.pathname === '/'

    return (
        <StyledFooter style={isHome ? {} : { background: '#f6f6f5' }}>
            <Container>
                <FooterNavRow>
                    <div style={{ display: 'flex', flex: 1 }}>

                        <FooterNavCol >
                            <div className={css`
                    font-size: 20px;
                    font-weight: 700;
                    color: #000;
                    cursor:pointer;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                `} onClick={() => navigate('/')}>
                                <img src="/images/logo.png" alt="" width={30} />
                                <div>Green<span style={{ color: '#fcc068' }}>Up</span>TX</div>
                            </div>
                        </FooterNavCol>
                        {nav.map((val, idx) => (
                            <FooterNavCol key={idx}>
                                <h6 style={{ fontWeight: '700' }}>{val.title}</h6>
                                {val.links.map((item, itemIdx) => {
                                    return (
                                        <div key={itemIdx}>
                                            {item.img ? <img src={item.img} alt={item.name} className={css`
                                                width:${item.name === 'eiqdigital' ? '220px' : '78px'};
                                                @media (max-width:990px){
                                                    width:80%;
                                                }
                                            `} />
                                                : <Link to={item.url} rel="noreferrer" target={item.target || '_self'}>
                                                    {item.name}
                                                </Link>}
                                        </div>
                                    )
                                })}
                            </FooterNavCol>
                        ))}
                        <FooterNavCol >
                            <h6 style={{ fontWeight: '700' }}>{t('Secure')}</h6>
                            <div>
                                <img src="/images/footer_logo.png" alt="amazon" className={css`
                                                width:${'78px'};
                                                @media (max-width:990px){
                                                    width:80%;
                                                }
                                            `} />
                            </div>
                            <div className={css`
                        img{
                            height:30px;
                        }
                        p {
                            font-size:15px;
                        }
                        @media (max-width:990px){
                            display:flex;
                            align-items:center;
                            flex-direction:column;
                            p{
                                font-size:14px;
                                text-align:center;
                            }
                        }
                    `}>
                                <img src="/images/logo_eiqdigital.png" alt=""
                                    style={{
                                        marginBottom: 10,
                                        cursor: 'pointer'
                                    }}

                                    onClick={() => {
                                        window.open('https://www.eiqdigital.com/')
                                    }}
                                />
                                <p>Foundational building block enabling the digital transformation of the retail energy industry.</p><br />

                                {moment().format("YYYY")} © EIQdigital. All Rights Reserved.<br />
                                TX #BR191039<br />
                                <a
                                    href="https://www.eiqdigital.com/PUCT_Required_Disclosure"
                                    target="_blank"
                                    rel="noreferrer">
                                    PUCT Required Disclosure
                                </a>
                            </div>
                        </FooterNavCol>

                    </div>
                </FooterNavRow>
            </Container>
        </StyledFooter>
    )
}

export default Footer
